import { useEffect } from "react";

/**
 * Sayfa-bazlı SEO: title, meta description, canonical ve opsiyonel JSON-LD'yi
 * çalışma anında <head>'e yazar. react-snap/prerender ile statik HTML'e gömülür,
 * Googlebot tarafından da render edildikten sonra okunur.
 *
 * Kullanım:
 *   <SEO
 *     title="Antalya Psikolog | Hakkımda - Uzm. Klinik Psk. Aysun Şeremet"
 *     description="..."
 *     canonical="https://aysunseremet.com/hakkimda"
 *     jsonLd={{ "@context": "https://schema.org", ... }}
 *   />
 */
export default function SEO({ title, description, canonical, jsonLd, noIndex }) {
  useEffect(() => {
    const cleanups = [];

    if (title) {
      const prevTitle = document.title;
      document.title = title;
      cleanups.push(() => { document.title = prevTitle; });
    }

    const ensureMeta = (name, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[name="${name}"]`);
      let created = false;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
        created = true;
      }
      const prev = el.getAttribute("content");
      el.setAttribute("content", content);
      cleanups.push(() => {
        if (created) el.remove();
        else if (prev != null) el.setAttribute("content", prev);
      });
    };

    if (description) ensureMeta("description", description);
    if (noIndex) ensureMeta("robots", "noindex, follow");

    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      let created = false;
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
        created = true;
      }
      const prev = link.getAttribute("href");
      link.setAttribute("href", canonical);
      cleanups.push(() => {
        if (created) link.remove();
        else if (prev != null) link.setAttribute("href", prev);
      });
    }

    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
      cleanups.push(() => script.remove());
    }

    return () => cleanups.forEach((fn) => fn());
  }, [title, description, canonical, jsonLd, noIndex]);

  return null;
}
